import React, { PureComponent, useState } from 'react'
import ReactTable from 'react-table'
import { Checkbox, Tooltip, Select } from 'antd'
import _ from 'lodash'
import { Div, Icon, P } from 'konsys-ui'
import moment from 'moment'
import {
  HeaderLabel, InputWithPlaceHolder, CellText, DropdownSelector, ActionSelector, DateFilterSelectors, DriverActionSelector,
} from '../../../components/shipping-order-components'
import { theme } from '../../../styles/_variables'
import {
  fuelStatus, fuelStatusText, status as shippingStatus, statusText,
} from '../constants'
import { isLatedMoreThan15days } from '../util-functions'

const { color } = theme

let refetchTimeout = null

export const textStatusSelector = (status) => {
  switch (status) {
    case shippingStatus.WAITING:
      return statusText.WAITING
    case shippingStatus.ASSIGNED:
      return statusText.ASSIGNED
    case shippingStatus.EXPIRED:
      return statusText.EXPIRED
    case shippingStatus.PICKEDUP:
      return statusText.PICKEDUP
    case shippingStatus.DELIVERED:
      return statusText.DELIVERED
    case shippingStatus.CANCELLED:
      return statusText.CANCELLED
    case shippingStatus.BILLED:
      return statusText.BILLED
    default:
      return 'ไม่ได้ระบุ'
  }
}

export const colorSelector = (status) => {
  switch (status) {
    case shippingStatus.WAITING:
      return '#97A0AF'
    case shippingStatus.ASSIGNED:
      return '#172B4D'
    case shippingStatus.EXPIRED:
      return '#FF6542'
    case shippingStatus.PICKEDUP:
      return '#003820'
    case shippingStatus.DELIVERED:
      return '#38B47F'
    case shippingStatus.CANCELLED:
      return '#FF5B37'
    case shippingStatus.BILLED:
      return '#00B8D9'
    default:
      return '#333'
  }
}

const textFuelStatusSelector = (status) => {
  switch (status) {
    case fuelStatus.NONE:
      return fuelStatusText.NONE
    case fuelStatus.WAITING:
      return fuelStatusText.WAITING
    case fuelStatus.EXPIRED:
      return fuelStatusText.EXPIRED
    case fuelStatus.FILLED:
      return fuelStatusText.FILLED
    case fuelStatus.BILLED:
      return fuelStatusText.BILLED
    case fuelStatus.CANCELLED:
      return fuelStatusText.CANCELLED
    case fuelStatus.LOST:
      return fuelStatusText.LOST
    case fuelStatus.PRINTED:
      return fuelStatusText.PRINTED
    default:
      return 'ไม่ได้ระบุ'
  }
}

const fuelColorSelector = (status) => {
  switch (status) {
    case fuelStatus.NONE:
      return '#172B4D'
    case fuelStatus.WAITING:
      return '#97A0AF'
    case fuelStatus.EXPIRED:
      return '#FF6542'
    case fuelStatus.FILLED:
      return '#38B47F'
    case fuelStatus.BILLED:
      return '#00B8D9'
    case fuelStatus.CANCELLED:
      return '#FF5B37'
    case fuelStatus.LOST:
      return '#FF5630'
    case fuelStatus.PRINTED:
      return '#a9c268'
    default:
      return '#333'
  }
}

export default class Table extends PureComponent {
  constructor() {
    super()
    this.state = {
      isChanged: false,
    }
    this.setIsChanged = this.setIsChanged.bind(this)
  }

  setIsChanged(value) {
    this.setState({ isChanged: value })
    this.props.setFiltered({ ...this.props.filtered, isChanged: value })
  }

  array = [{
    accessor: 'checkbox',
    filterable: true,
    sortable: false,
    Cell: props => (
      <Checkbox
        disabled={props.tdProps.rest.checkDisabled || !_.includes([shippingStatus.DELIVERED], props.original.status) || isLatedMoreThan15days(props.original.status, props.original.assignDate) }
        key={props.original.id}
        checked={_.includes(props.tdProps.rest.check, props.original.id)}
        onChange={(e) => {
          if (e.target.checked) {
            props.tdProps.rest.setCheck(_.concat(props.tdProps.rest.check, props.original.id))
            props.tdProps.rest.setShippingOrders(_.concat(props.tdProps.rest.shippingOrders, props.original))
          } else {
            props.tdProps.rest.setCheck(_.remove(_.cloneDeep(props.tdProps.rest.check), n => n !== props.original.id))
            props.tdProps.rest.setShippingOrders(_.remove(_.cloneDeep(props.tdProps.rest.shippingOrders), n => n.id !== props.original.id))
          }
        }}
      />
    ),
    width: 40,
    Filter: props => (
      <Div display='flex' justifyContent='space-between'>
        <Checkbox
          style={{ paddingLeft: 3 }}
          checked={this.props.isCheckAll}
          disabled={this.props.checkDisabled}
          onChange={(e) => {
            props.onChange(e)
          }}
        />
      </Div>
    ),
  }, {
    Header: () => (
        <HeaderLabel>
          เล่มที่ <Icon color={color.coolGrey}/>
        </HeaderLabel>
    ),
    accessor: 'shippingVolume',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.id, filter.value),
    width: 100,
  }, {
    Header: () => (
        <HeaderLabel>
          เลขที่ <Icon color={color.coolGrey}/>
        </HeaderLabel>
    ),
    accessor: 'shippingNumber',
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: false,
    filterable: true,
    width: 100,
  }, {
    Header: <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Customer.companyName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 390,
  }, {
    Header: <HeaderLabel>ทะเบียนรถ</HeaderLabel>,
    accessor: 'Truck.plateNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.to, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={colorSelector(props.value)} bold>{textStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: shippingStatus.ALL, text: statusText.ALL },
        { value: shippingStatus.WAITING, text: statusText.WAITING },
        { value: shippingStatus.ASSIGNED, text: statusText.ASSIGNED },
        { value: shippingStatus.EXPIRED, text: statusText.EXPIRED },
        { value: shippingStatus.PICKEDUP, text: statusText.PICKEDUP },
        { value: shippingStatus.DELIVERED, text: statusText.DELIVERED },
        { value: shippingStatus.CANCELLED, text: statusText.CANCELLED },
        { value: shippingStatus.BILLED, text: statusText.BILLED },
      ]
      return (
        <DropdownSelector
          key='filter'
          data={arr}
          value={this.props.filtered.status || shippingStatus.ALL}
          handleChange={e => onChange(e)}
          filter={true}
          statusAttr='ทั้งหมด'
        />
      )
    },
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะน้ำมัน</HeaderLabel>,
    accessor: 'FuelOrder.status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={fuelColorSelector(props.value)} bold>{textFuelStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: fuelStatus.ALL, text: fuelStatusText.ALL },
        { value: fuelStatus.NONE, text: fuelStatusText.NONE },
        { value: fuelStatus.WAITING, text: fuelStatusText.WAITING },
        { value: fuelStatus.EXPIRED, text: fuelStatusText.EXPIRED },
        { value: fuelStatus.FILLED, text: fuelStatusText.FILLED },
        { value: fuelStatus.PRINTED, text: fuelStatusText.PRINTED },
        { value: fuelStatus.CANCELLED, text: fuelStatusText.CANCELLED },
        { value: fuelStatus.BILLED, text: fuelStatusText.BILLED },
        { value: fuelStatus.LOST, text: fuelStatusText.LOST },
      ]
      return (
          <DropdownSelector
            key='filter'
            data={arr}
            value={this.props.filtered.FuelOrder || fuelStatus.ALL}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
          />
      )
    },
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} key={props.original.id} refetch={props.tdProps.rest.refetch} availableOrder={props.original.Job.availableOrder} shippingsAmount={props.original.Job.shippings.length}/>,
    width: 150,
  }]

  driverArray = [{
    Header: () => (
        <HeaderLabel>
          เล่มที่ <Icon color={color.coolGrey}/>
        </HeaderLabel>
    ),
    accessor: 'shippingVolume',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.id, filter.value),
    width: 100,
  }, {
    Header: () => (
        <HeaderLabel>
          เลขที่ <Icon color={color.coolGrey}/>
        </HeaderLabel>
    ),
    accessor: 'shippingNumber',
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: false,
    filterable: true,
    width: 100,
  }, {
    Header: <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Customer.companyName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 390,
  }, {
    Header: <HeaderLabel>ทะเบียนรถ</HeaderLabel>,
    accessor: 'Truck.plateNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.to, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={colorSelector(props.value)} bold>{textStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: shippingStatus.ALL, text: statusText.ALL },
        { value: shippingStatus.WAITING, text: statusText.WAITING },
        { value: shippingStatus.ASSIGNED, text: statusText.ASSIGNED },
        { value: shippingStatus.EXPIRED, text: statusText.EXPIRED },
        { value: shippingStatus.PICKEDUP, text: statusText.PICKEDUP },
        { value: shippingStatus.DELIVERED, text: statusText.DELIVERED },
        { value: shippingStatus.CANCELLED, text: statusText.CANCELLED },
        { value: shippingStatus.BILLED, text: statusText.BILLED },
      ]
      return (
        <DropdownSelector
          key='filter'
          data={arr}
          value={this.props.filtered.status || shippingStatus.ALL}
          handleChange={e => onChange(e)}
          filter={true}
          statusAttr='ทั้งหมด'
        />
      )
    },
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะน้ำมัน</HeaderLabel>,
    accessor: 'FuelOrder.status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={fuelColorSelector(props.value)} bold>{textFuelStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: fuelStatus.ALL, text: fuelStatusText.ALL },
        { value: fuelStatus.NONE, text: fuelStatusText.NONE },
        { value: fuelStatus.WAITING, text: fuelStatusText.WAITING },
        { value: fuelStatus.EXPIRED, text: fuelStatusText.EXPIRED },
        { value: fuelStatus.FILLED, text: fuelStatusText.FILLED },
        { value: fuelStatus.PRINTED, text: fuelStatusText.PRINTED },
        { value: fuelStatus.CANCELLED, text: fuelStatusText.CANCELLED },
        { value: fuelStatus.BILLED, text: fuelStatusText.BILLED },
        { value: fuelStatus.LOST, text: fuelStatusText.LOST },
      ]
      return (
          <DropdownSelector
            key='filter'
            data={arr}
            value={this.props.filtered.FuelOrder || fuelStatus.ALL}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
          />
      )
    },
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <DriverActionSelector props={props} key={props.original.id} refetch={props.tdProps.rest.refetch}/>,
    width: 150,
  }]

  render() {
    const {
      data, current, setCurrent, refetch, check, setCheck, word, filtered, shippingOrders, setShippingOrders, setCheckDelivered, setFiltered, setSorted, dateType, setDateType, isDriver = false,
    } = this.props
    return (
      <Div>
        {
          !isDriver
          && <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' margin='0 0 0'>
          <Div display='flex' flexDirection='column' alignItems='flex-end' justifyContent='flex-start' margin='0 0 0'>
            <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' margin='0 0 16px'>
            <Checkbox
              checked={this.state.isChanged}
              onChange={() => this.setIsChanged(!this.state.isChanged)}
              style={{ borderRight: 'solid 1px #999', marginRight: 8 }}
            >
              เฉพาะใบสั่งบรรทุกที่มีการแก้ไข
            </Checkbox>
              <P margin='0 8px 0 0' whiteSpace='nowrap'>เรียงตาม</P>
              <Select
                defaultValue={true}
                placeholder={data.placeholder}
                onChange={e => setSorted([{ id: 'updatedAt', desc: e }])}
                style={{ width: 100, margin: '0 16px 0 0' }}
              >
                <Select.Option key={1} value={true}>ล่าสุด</Select.Option>
                <Select.Option key={0} value={false}>เก่าสุด</Select.Option>
              </Select>
              <P margin='0 8px 0 0' whiteSpace='nowrap'>กรองตามวัน</P>
              <DateFilterSelectors filtered={filtered} setFiltered={setFiltered} dateType={dateType} setDateType={setDateType} setCurrent={setCurrent}/>
            </Div>
          <P margin='0 0 8px 0'>{(dateType === 'assignDate' && !_.isNull(filtered.startAssignDate) && !_.isNull(filtered.endAssignDate))
            ? `${moment(filtered.startAssignDate).format('DD/MM/YYYY')} - ${moment(filtered.endAssignDate).format('DD/MM/YYYY')}`
            : (dateType === 'recordDate' && !_.isNull(filtered.startRecordDate) && !_.isNull(filtered.endRecordDate))
              ? `${moment(filtered.startRecordDate).format('DD/MM/YYYY')} - ${moment(filtered.endRecordDate).format('DD/MM/YYYY')}`
              : (dateType === 'createdDate' && !_.isNull(filtered.startCreatedAt) && !_.isNull(filtered.endCreatedAt))
                ? `${moment(filtered.startCreatedAt).format('DD/MM/YYYY')} - ${moment(filtered.endCreatedAt).format('DD/MM/YYYY')}`
                : (dateType === 'deliveryDate' && !_.isNull(filtered.startDeliveryDate) && !_.isNull(filtered.endDeliveryDate))
                  ? `${moment(filtered.startDeliveryDate).format('DD/MM/YYYY')} - ${moment(filtered.endDeliveryDate).format('DD/MM/YYYY')}`
                  : ''}</P>
          <P margin='0 0 8px 0'>{`ใบสั่งบรรทุกทั้งหมด: ${data.ShippingorderList.totalFilter} ใบ`}</P>
          <P margin='0 0 8px 0'>{`จำนวนที่เลือก: ${shippingOrders.length} ใบ`}</P>
          </Div>
        </Div>
        }
        <ReactTable
          className='table'
          data={data.ShippingorderList.lists} // *
          resizable={false}
          columns={isDriver ? this.driverArray : this.array}
          minRows={5}
          row={data.ShippingorderList.lists.length}
          manual
          showPageSizeOptions={false}
          getTdProps={() => ({
            // disabled: true, refetch, check, setCheck, checkDisabled: (_.isUndefined(word) || !checkDelivered), shippingOrders, setShippingOrders,
            disabled: true, refetch, check, setCheck, checkDisabled: _.isUndefined(word), shippingOrders, setShippingOrders,
          })} // *
          getTrProps={(state, rowInfo) => { // *
            if (rowInfo) {
              return {
                style: {
                  padding: '8px 0',
                  backgroundColor: '#ffffff',
                  borderLeft: `3px solid ${colorSelector(rowInfo.original.status)}`,
                },
              }
            } return {}
          }}
          previousText='ก่อนหน้า'
          nextText='ถัดไป'
          pageText='หน้า'
          ofText='จาก'
          noDataText='ไม่พบข้อมูล'
          page={current}
          pages={Math.ceil(data.ShippingorderList.totalFilter / 50)}
          onPageChange={page => setCurrent(page)}
          onFilteredChange={async (newFiltered, info) => {
            if (info.id === 'checkbox') {
              const currentList = data.ShippingorderList.lists
              if (_.find(newFiltered, v => v.id === 'checkbox').value.target.checked) {
                setCheck(_.concat(currentList.map(v => v.id), _.remove(_.cloneDeep(check), o => !_.includes(currentList.map(v => v.id), o))))
                setShippingOrders(_.concat(currentList, _.remove(_.cloneDeep(shippingOrders), o => !_.includes(currentList.map(v => v.id), o.id))))
              } else {
                setCheck(_.remove(_.cloneDeep(check), o => !_.includes(currentList.map(v => v.id), o)))
                setShippingOrders(_.remove(_.cloneDeep(currentList), o => !_.includes(currentList.map(v => v.id), o.id)))
              }
            } else {
              if (_.isEmpty(_.find(newFiltered, o => o.id === 'status'))) setCheckDelivered(false)
              const newOjb = {}
              await newFiltered.forEach((v) => {
                switch (v.id) {
                  case 'Customer.companyId':
                    Object.assign(newOjb, { ...filtered, companyId: v.value })
                    break
                  case 'Customer.companyName':
                    Object.assign(newOjb, { ...filtered, companyName: v.value })
                    break
                  case 'Truck.plateNumber':
                    Object.assign(newOjb, { ...filtered, plateNumber: v.value })
                    break
                  case 'Driver.fullname':
                    Object.assign(newOjb, { ...filtered, fullname: v.value })
                    break
                  case 'FuelOrder.status':
                    Object.assign(newOjb, { ...filtered, FuelOrder: v.value })
                    break
                  case 'status':
                    if (v.value === 'DELIVERED') setCheckDelivered(true)
                    else setCheckDelivered(false)
                    Object.assign(newOjb, { ...filtered, [v.id]: v.value })
                    break
                  default:
                    Object.assign(newOjb, { ...filtered, [v.id]: v.value })
                    break
                }
                setCheck([])
              })
              setCurrent(0)
              clearTimeout(refetchTimeout)
              refetchTimeout = setTimeout(() => {
                setFiltered(newOjb)
              }, 750)
            }
          }}
          onSortedChange={async (newSorted) => {
            setSorted(newSorted)
            setCurrent(0)
            setCheck([])
          }}
        />
    </Div>
    )
  }
}
